import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { fetchProductAccumulated } from 'store/actions/products/fetchProducts';
import styled from 'styled-components';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

const TextFieldWrapper = styled.div`
    margin: 0 0 20px 0;
`;

const Label = styled.div`
    margin-bottom: 3px;
    font-size: 14px;
    line-height: 1.2;
    font-weight: bold;
`;

const Text = styled.div`
    font-size: 16px;
    line-height: 1.2;
`;

class ProductTextField extends React.Component {
    componentDidMount() {
        const { productId, product, fetch } = this.props;

        if (utils.isEmpty(product)) {
            fetch(productId);
        }
    }

    render() {
        const { label, product, translate } = this.props;

        if (utils.isEmpty(product)) {
            return null;
        }

        return (
            <TextFieldWrapper>
                { label &&
                    <Label>{ translate(label) }</Label>

                }

                <Text>{ product.title }</Text>
            </TextFieldWrapper>
        );
    }
}

ProductTextField.propTypes = {
    fetch: PropTypes.func.isRequired,
    label: PropTypes.string,
    product: PropTypes.object,
    productId: PropTypes.string.isRequired,
    translate: PropTypes.func,
};

const mapStateToProps = (state, props) => {
    const { record, source } = props;

    let identifier = null;

    if (record[source]) {
        identifier = record[source];
    }

    return {
        product: state.products.data[identifier],
        productId: identifier,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetch: (productId) => {
            dispatch(fetchProductAccumulated({
                id: productId,
            }));
        },
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(ProductTextField);



// WEBPACK FOOTER //
// ./src/components/field/ProductTextField.js